import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TicketTask } from '@app/models';
import { TcTicketService } from 'src/app/shared/services';

@Component({
  selector: 'app-sprint-inner-column',
  templateUrl: './sprint-inner-column.component.html',
  standalone: false,
})
export class SprintInnerColumnComponent {
  @Input() ticketTask?: TicketTask;
  @Input() title?: string | null;
  @Input() user!: string;
  @Input() color?: string;
  @Input() parentIndex?: number;
  @Input() readOnly: boolean = false;
  @Input() isBeta: boolean = false;

  @Output() dragStartEmitter = new EventEmitter();
  @Output() dropEmitter = new EventEmitter();
  @Output() openTicketModalEmitter = new EventEmitter();

  constructor(public tcTicketService: TcTicketService) {}

  openTicketModal(event, ticketTask) {
    this.openTicketModalEmitter.emit(ticketTask);
  }
}
